import cookies from '../../cookies.js';
import { getToken } from '../../cmtoken.js';

/**
 * Add to shopping cart
 * @param {string} itemId item's id license, pid or somethings similar
 * @returns {object} shopping cart data 
 */
export async function addToShoppingCart(itemId) {
  let cartId = getCartId();
  
  const token = await getToken();
  
  const response = await fetch('/api/cart/v1/add/?cm_lang=fi_FI', {
    method: 'POST',
    body: JSON.stringify({
      type: 'vehicle',
      id: cartId,
      itemid: itemId,
      token: token,      
    }),
    headers: { 'Content-Type': 'application/json' }
  });

  const data = await response.json();

  if (!cartId || (cartId && cartId !== data.id)){
    cookies.setCookie('cart', data.id, 365*2);
    cartId = data.id;
  }

  // update locale storage and cart icon
  return await updateCartData(cartId);
}

/**
 * Remove item from the shopping cart. 
 * Update cart state from the server, and update local storage state in same go.
 * 
 * @param {string} itemId license number, pid, or some unique id
 * @returns {object} cart data
 */
export async function removeFromShoppingCart(itemId) {
  let cartId = getCartId();
  
  const token = await getToken();

  await fetch('/api/cart/v1/delete-article/?cm_lang=fi_FI', {
    method: 'DELETE',
    body: JSON.stringify({
      type: 'vehicle',
      itemid: itemId,
      id: cartId,
      token: token
    }),
    headers: { 'Content-Type': 'application/json' }
  });

  // update locale storage
  return await updateCartData(cartId);
}

/**
 * Update local storage cart data
 * @param {string} cartId cartid
 * @returns {object} cart data from sever.
 */
async function updateCartData(cartId) {
  try {
    const responseJSON = await getCart(cartId);

    localStorage.setItem('cart', JSON.stringify(responseJSON));
    // update cart icon
    window.dispatchEvent( new CustomEvent('cartUpdate') );

    return responseJSON;
  } catch(error) {
    console.warn('Error loading cart data', error);
  }
}

/**
 * Get cart from the server.
 * 
 * @param {string} cartId shopping cart id
 * @returns {object} cart data from server
 */
export async function getCart(cartId) {
  
  const token = await getToken();

  const response = await fetch(`/api/cart/v1/my-cart-formatted/?id=${cartId}&token=${token}&cm_lang=fi_FI`, {
    method: 'GET'
  });

  return response.json();
}

/**
 * Return cart data from local storage
 * @throw {Error} if JSON parsing fails
 * @returns {object} cart data from local storage
 */
export function getCartFromLocalStorage() {
  const cartDataString = localStorage.getItem('cart');
  const cartData = JSON.parse(cartDataString);
  return cartData ?? { items: []}
}

/**
 * Check is car in cart
 * @param {object} carData carData
 * @param {object} cartData cartData
 * @returns {boolean} true is returned if car is in the cart
 */
export function isCarDataInCart(carData, cartData) {  
  return cartData?.items?.some( item => {     
    return item.type === 'vehicle' && (item.id === carData.license || item.id === carData.pid);
  });
}

/**
 * Return cart id from a cookie.
 * @returns {string} cart id or empty string if cart cookie is not found
 */
export function getCartId() {
  return cookies.getCookie('cart') ?? null;
}